import type { UserSummary } from '@/types/api';
import { apiPage, apiRequest, withQuery } from '@/api/client';

/** The people who can use the panel (the «Сотрудники» screen). */
export const usersApi = {
  list: (filter: { search?: string; cursor?: string | null } = {}) => {
    const params = new URLSearchParams({ limit: '50' });
    if (filter.search) params.set('search', filter.search);
    if (filter.cursor) params.set('cursor', filter.cursor);
    return apiPage<UserSummary>(withQuery('/users', params));
  },

  create: (input: { login: string; email: string; password: string; roles: string[] }) =>
    apiRequest<UserSummary>('/users', { method: 'POST', body: input }),

  remove: (id: string, confirmation: string) =>
    apiRequest<{ ok: boolean }>(`/users/${id}`, { method: 'DELETE', body: { confirmation } }),

  setStatus: (id: string, status: 'active' | 'disabled') =>
    apiRequest<{ ok: boolean }>(`/users/${id}/${status === 'active' ? 'enable' : 'disable'}`, { method: 'POST' }),

  setRoles: (id: string, roles: string[]) =>
    apiRequest<{ ok: boolean }>(`/users/${id}/roles`, { method: 'PUT', body: { roles } }),

  resetMfa: (id: string) => apiRequest<{ ok: boolean }>(`/users/${id}/mfa/reset`, { method: 'POST' }),
};
